export type ExportTable = {
  name: string;
  columns: string[];
  rows: Array<Array<string | number | null | undefined>>;
};

export type ExportSection = {
  title: string;
  tables: ExportTable[];
};

const escapeCsvValue = (value: string) => {
  if (value.includes('"') || value.includes(",") || value.includes("\n")) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
};

export const buildCsv = (sections: ExportSection[]) => {
  const lines: string[] = [];

  sections.forEach((section) => {
    lines.push(section.title);
    section.tables.forEach((table) => {
      lines.push(table.name);
      lines.push(table.columns.join(","));
      table.rows.forEach((row) => {
        const normalized = row.map((cell) => {
          if (cell === null || cell === undefined) return "";
          return escapeCsvValue(String(cell));
        });
        lines.push(normalized.join(","));
      });
      lines.push("");
    });
    lines.push("");
  });

  return lines.join("\n");
};

export const buildClipboardText = (sections: ExportSection[]) => {
  const lines: string[] = [];
  sections.forEach((section) => {
    lines.push(section.title);
    lines.push("-".repeat(section.title.length));
    section.tables.forEach((table) => {
      lines.push(table.name);
      lines.push(table.columns.join(" | "));
      table.rows.forEach((row) => {
        const normalized = row.map((cell) => (cell === null || cell === undefined ? "—" : String(cell)));
        lines.push(normalized.join(" | "));
      });
      lines.push("");
    });
    lines.push("");
  });
  return lines.join("\n");
};

export const exportToExcel = async (sections: ExportSection[], fileName: string) => {
  const xlsx = await import("xlsx");
  const wb = xlsx.utils.book_new();

  sections.forEach((section) => {
    section.tables.forEach((table) => {
      const sheetName = `${section.title} - ${table.name}`.slice(0, 31);
      const rows = [table.columns, ...table.rows.map((row) => row.map((cell) => cell ?? ""))];
      const ws = xlsx.utils.aoa_to_sheet(rows);
      xlsx.utils.book_append_sheet(wb, ws, sheetName);
    });
  });

  const safeName = fileName.toLowerCase().endsWith(".xlsx") ? fileName : `${fileName}.xlsx`;
  xlsx.writeFile(wb, safeName);
};
